export default {
  breadcrumb: {
    settlements: "Radicaciones >",
    settlementId: "Radicación {id} "
  },
  title: "Radicación",
  createdAt: "Fecha de radicación",
  totalAmount: "Monto Total",
  sponsor: "Aseguradora: ",
  loadingDataLabel: "Cargando reclamos",
  emptyDataLabel: "No hay reclamos en esta radicación",
  resultLabel: "{result} Reclamos",
  NoResults: "No se encontraron reclamos",
  grid: {
    authorizationId: "ID Reclamo",
    createdAt: "Fecha de creación",
    beneficiary: "Beneficiario",
    memberCode: "Carnet",
    branch: "Sucursal",
    amount: "Monto a pagar"
  },
  filters: {
    searchCode: "Buscar por ID de reclamo"
  }
}
